import React, { useEffect, useRef, useState } from "react";
import { Dropdown, List, Typography } from "antd";
import styles from "./ChatMessage.module.css";
import profileImage from "../../assets/dummy.png";
import profileImage2 from "../../assets/profile2.png";
import ArrowIcon from "../../assets/arrow.png";
import LinkIcon from "../../assets/link.png";
import { useDispatch, useSelector } from "react-redux";
import ChatMiddleware from "../../store/Middlewares/ChatMiddleware";
import Pusher from 'pusher-js';
import ChatActions from "../../store/Actions/ChatActions";
import { IMG_URL } from "../../store/Apis";
import DocViewer from "react-doc-viewer";
import moment from "moment";

const ChatMessage = (data) => {
    const Data = data?.data;

    const dispatch = useDispatch()
    const [userdetails, setuserDetails] = useState(null)
    const user = useSelector(state => state.AuthReducer.user)
    const [userDetails, setuserdetails] = useState(null)
    const MessageList = useSelector(state => state.ChatReducer.MessageList)
    const MessageListPagination = useSelector(state => state.ChatReducer.MessageListPagination)
    const [typeMessage, settypeMessage] = useState('')
    const [loader, setLoader] = useState(false)
    //   const [ImageModal, setImageModal] = useState(false)
    const [SelectedImage, setSelectedImage] = useState(null)
    const channel = useRef(null)
    const messagesEndRef = useRef(null)

    const { Text } = Typography;
    const fileAudio = React.useRef();
    const fileVideo = React.useRef();
    const fileDocument = React.useRef();
    const fileImage = React.useRef();

    const handleClickAudio = (event) => {
        fileAudio.current.click();
    };
    const handleClickVideo = (event) => {
        fileVideo.current.click();
    };
    const handleClickDocument = (event) => {
        fileDocument.current.click();
    };
    const handleClickImage = (event) => {
        fileImage.current.click();
    };


    const scrollToBottom = () => {
        messagesEndRef.current?.scrollIntoView({ behavior: "smooth" })
    }


    useEffect(() => {
        getChatlist()
        initiatePusher()
        if (Data?.to_user?.id == user?.id) {
            setuserDetails(Data?.from_user);
        } else if (Data?.from_user?.id == user?.id) {
            setuserDetails(Data?.to_user);
        }
    }, [])

    useEffect(() => {

        return () => {
            if (channel.current)
                channel.current.unsubscribe()
        }
    }, [Data?.id])

    const initiatePusher = () => {
        let pusher = new Pusher('d977b543ea849a1c6f44', { cluster: 'ap2' });
        channel.current = pusher.subscribe(`user.${Data?.id}`);
        channel.current.bind('App\\Events\\Message', (response) => {
            if (Data?.id == response?.message?.chatlist_id) {
                dispatch(ChatActions.updateMessageList(response?.message))
                scrollToBottom()
            }
        });
    };

    const getChatlist = () => {
        let chatdata = {
            id: Data?.id,
            next_page_url: undefined
        }
        dispatch(ChatMiddleware.getViewChatlist(chatdata)).then((data) => {
            scrollToBottom()
        })
    }

    const onPressLoadMore = () => {
        if (MessageListPagination?.next_page_url) {
            let chatdata = {
                next_page_url: MessageListPagination?.next_page_url,
            };
            dispatch(ChatMiddleware.getViewChatlist(chatdata))
        }
    };

    const onPressSendMessage = () => {
        if (typeMessage) {
            setLoader(true)
            if (user?.id == Data?.to_user?.id) {
                let userdata = {
                    userId: Data?.from_user?.id,
                    type: 'text',
                    typeMessage: typeMessage,
                }
                dispatch(ChatMiddleware.SendMessage(userdata))
                    .then((data) => {
                        setLoader(false);
                        settypeMessage('');
                        scrollToBottom()
                    })
                    .catch(() => setLoader(false));
            } else if (user?.id == Data?.from_user?.id) {
                let userdata = {
                    userId: Data?.to_user?.id,
                    type: 'text',
                    typeMessage: typeMessage,
                };
                dispatch(ChatMiddleware.SendMessage(userdata))
                    .then(() => {
                        setLoader(false);
                        settypeMessage('');
                        scrollToBottom();
                    })
                    .catch(() => setLoader(false));
            }
        }
    };

    const UploadImage = (data) => {
        console.log('selected File', data?.file)
        console.log('selected type', data?.type)
        if (user?.id == Data?.to_user?.id) {
            let userdata = {
                userId: Data?.from_user?.id,
                type: data?.type,
                typeMessage: data?.file?.name,
                media: data?.file
            }
            dispatch(ChatMiddleware.SendMessage(userdata))
                .then(() => {
                    setLoader(false);
                    settypeMessage('');
                })
                .catch(() => setLoader(false));
        } else if (user?.id == Data?.from_user?.id) {
            let userdata = {
                userId: Data?.to_user?.id,
                type: data?.type,
                typeMessage: data?.file?.name,
                media: data?.file
            };
            dispatch(ChatMiddleware.SendMessage(userdata))
                .then(() => {
                    setLoader(false);
                    settypeMessage('');
                })
                .catch(() => setLoader(false));
        }

    }


    const renderChats = (item) => {
        console.log('item', item)
        if (user?.id !== item?.sent_from?.id) {
            return (
                <>
                    <div className={styles.chatSection}>
                        <img src={item?.sent_from?.profile_image
                            ? IMG_URL + item?.sent_from?.profile_image
                            : profileImage} className={styles.profileIcon} />
                        <div style={{ zIndex: 10, width: "80%" }}>
                            <div className={styles.person_one_message_box}>
                                {item?.type == 'text' ? <Text className={styles.text}>{item?.message}</Text> : null}
                                {item?.type == 'photo' ?
                                    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                                        <img style={{ height: '200px', width: '300px' }} src={IMG_URL + item?.media} />
                                        {/* <iframe style={{width:'100%',height:'100%'}} src={IMG_URL + item?.media} ></iframe> */}
                                        <a href={IMG_URL + item?.media} target="_blank" title="Download"> {item?.media}</a>
                                    </div> :
                                    item?.type == 'document' ?
                                        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                                            <a href={IMG_URL + item?.media} target="_blank" title="Download"> (Download)</a>
                                        </div> :
                                        item?.type == 'video' ?
                                            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                                                <iframe src={IMG_URL + item?.media} ></iframe>
                                                <a href={IMG_URL + item?.media} target="_blank" title="Download"> {item?.media}</a>
                                            </div>
                                            :
                                            item?.type == 'audio' ?
                                                <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                                                    <iframe src={IMG_URL + item?.media} ></iframe>
                                                    <a href={IMG_URL + item?.media} target="_blank" title="Download"> {item?.media}</a>
                                                </div> :
                                                null}
                            </div>
                            <div style={{ display: 'flex', flexDirection: 'column', marginLeft: '20px' }}>
                                <Text className={styles.chatTime}>{item?.created_at ? moment(item?.created_at).format('hh:mm A') : 'N/A'}</Text>
                            </div>
                        </div>
                    </div>

                    <div ref={messagesEndRef} />
                </>
            );
        } else {
            return (
                <div>
                    <div
                        style={{
                            width: "100%",
                            display: "flex",
                            justifyContent: "flex-end",
                        }}
                    >
                        <div className={styles.chatSection2}>
                            <div style={{ zIndex: 10, width: "70%" }}>
                                <div className={styles.person_two_message_box}>
                                    {item?.type == 'text' ? <Text className={styles.text}>{item?.message}</Text> : null}
                                    {item?.type == 'photo' ?
                                        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                                            {/* <iframe src={IMG_URL + item?.media} ></iframe> */}
                                            <img style={{ height: '200px', width: '300px' }} src={IMG_URL + item?.media} />
                                            <a href={IMG_URL + item?.media} target="_blank" title="Download"> {item?.media}</a>
                                        </div> :
                                        item?.type == 'document' ?
                                            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                                                <a href={IMG_URL + item?.media} target="_blank" title="Download"> (Download)</a>
                                            </div> :
                                            item?.type == 'video' ?
                                                <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                                                    <iframe src={IMG_URL + item?.media} ></iframe>
                                                    <a href={IMG_URL + item?.media} target="_blank" title="Download"> {item?.media}</a>
                                                </div>
                                                :
                                                item?.type == 'audio' ?
                                                    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                                                        <iframe src={IMG_URL + item?.media} ></iframe>
                                                        <a href={IMG_URL + item?.media} target="_blank" title="Download"> {item?.media}</a>
                                                    </div> :
                                                    null}
                                </div>
                                <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-end', marginRight: '20px' }}>
                                    <Text className={styles.chatTime}>{item?.created_at ? moment(item?.created_at).fromNow() : 'N/A'}</Text>
                                </div>
                            </div>
                            <img src={user?.profile_image
                                ? IMG_URL + user?.profile_image
                                : profileImage} className={styles.profileIcon} />
                        </div>
                    </div>

                    <div ref={messagesEndRef} />
                </div>
            );
        }
    };

    const items = [
        {
            key: '1',
            label: (
                <div>
                    <text onClick={() => { handleClickAudio() }}>audio</text>
                    <input
                        type="file"
                        ref={fileAudio}
                        accept={"audio/*"}
                        onChange={(e) => {
                            UploadImage({ file: e.target.files[0], type: 'audio' });
                        }}
                        style={{ display: "none" }}
                    />
                </div>
            ),
        },
        {
            key: '2',
            label: (
                <div>
                    <text onClick={() => { handleClickDocument() }}>document</text>
                    <input
                        type="file"
                        ref={fileDocument}
                        accept={".doc,.docx,.xml,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document"}
                        onChange={(e) => {
                            UploadImage({ file: e.target.files[0], type: 'document' });
                        }}
                        style={{ display: "none" }}
                    />
                </div>
            ),
        },
        {
            key: '3',
            label: (
                <div>
                    <text onClick={() => { handleClickVideo() }}>video</text>
                    <input
                        type="file"
                        ref={fileVideo}
                        accept={"video/*"}
                        onChange={(e) => {
                            UploadImage({ file: e.target.files[0], type: 'video' });
                        }}
                        style={{ display: "none" }}
                    />
                </div>

            ),
        },
        {
            key: '4',
            label: (
                <div>
                    <text onClick={() => { handleClickImage() }}>photo</text>
                    <input
                        type="file"
                        ref={fileImage}
                        accept={"image/*"}
                        onChange={(e) => {
                            UploadImage({ file: e.target.files[0], type: 'photo' });
                        }}
                        style={{ display: "none" }}
                    />
                </div>

            ),
        },
    ];


    const loadMore =
        MessageListPagination?.next_page_url ? (
            <div
                style={{
                    textAlign: 'center',
                    marginTop: 12,
                    height: 32,
                    lineHeight: '32px',
                    display: 'flex', justifyContent: 'center'
                }}
            >
                <button onClick={onPressLoadMore} className={styles.loadMore_button}>
                    Load More
                </button>
            </div>
        ) : null;

    return (

        <div className={styles.mainBox}>
            <List
                ref={messagesEndRef}
                className={styles.chatList}
                itemLayout="horizontal"
                dataSource={MessageList.slice(0).reverse()}
                renderItem={renderChats}
                header={loadMore}
            />

            <div className={styles.inputDiv} ref={messagesEndRef}>
                <div className={styles.chatInputSubDiv}>
                    <input
                        value={typeMessage}
                        onChange={(e) => settypeMessage(e.target.value)}
                        className={styles.chatInput}
                        placeholder={"Send message"}
                        onKeyDown={(event = React.KeyboardEvent) => {
                            if (event.key === 'Enter') {
                                onPressSendMessage()
                            }
                        }}

                    />
                    <Dropdown
                        menu={{
                            items,
                        }}
                        placement="top"
                        arrow={{
                            pointAtCenter: true,
                        }}
                    >
                        <img src={LinkIcon} className={styles.sendIcon} />

                    </Dropdown>
                    {/* <input
                            type="file"
                            ref={attachmentFileinput}
                            // accept={"image/*"}
                            onChange={(e) => {
                                UploadImage(e.target.files[0]);
                            }}
                            style={{ display: "none" }}
                        /> */}
                </div>
                <img
                    src={ArrowIcon}
                    className={styles.sendIcon}
                    onClick={() => onPressSendMessage()}
                />
            </div>
        </div>
    );
};

export default ChatMessage;
